import { FC, useState } from 'react';
import JsonEditorModal from '@/components/admin/JsonEditorModal';
import { useUpdateQuestion } from '@/api/useAdminPastPaper';
import { Database } from '@/_constants/database.types';

type QuestionRow = Database['public']['Tables']['questions']['Row'];

type QuestionMarkSchemeEditorProps = {
  question: QuestionRow;
  pastPaperId: string;
};

const QuestionMarkSchemeEditor: FC<QuestionMarkSchemeEditorProps> = ({ question, pastPaperId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { mutate: updateQuestion, isPending } = useUpdateQuestion();

  const hasMarkScheme = question.mark_scheme_content !== null;

  const handleSave = (data: unknown) => {
    updateQuestion(
      {
        questionId: question.id,
        pastPaperId,
        updates: { mark_scheme_content: data },
      },
      {
        onSuccess: () => setIsOpen(false),
      }
    );
  };

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="text-[#C87941] font-medium hover:text-[#a5612f] transition-colors"
      >
        {hasMarkScheme ? 'Edit' : 'Add'}
      </button>

      <JsonEditorModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSave={handleSave}
        initialData={question.mark_scheme_content}
        title={`Mark Scheme - ${question.category || 'Question'}`}
        isSaving={isPending}
      />
    </>
  );
};

export default QuestionMarkSchemeEditor;
